import { QueueOrderSearchStatus } from "../../../../../../../models/queue/queueOrderSearchRequest";

export const getStatusChipProps = (orderStatus: number) => {
  switch (orderStatus) {
    case QueueOrderSearchStatus.Pending: // 1
      return {
        color: "primary" as const,
        sx: { bgcolor: "#e3f2fd", color: "#1976d2" },
      };
    case QueueOrderSearchStatus.InProgress: // 2
      return {
        color: "warning" as const,
        sx: { bgcolor: "#fff3e0", color: "#f57c00" },
      };
    case QueueOrderSearchStatus.Done: // 3
      return {
        color: "success" as const,
        sx: { bgcolor: "#e8f5e8", color: "#2e7d32" },
      };
    case QueueOrderSearchStatus.Scheduled: // 4
      return  { color: "default" as const };
    default:
      return { color: "default" as const };
  }
};

export const getStatusLabel = (orderStatus: number) => {
  switch (orderStatus) {
    case QueueOrderSearchStatus.All:
      return "All";
    case QueueOrderSearchStatus.Pending:
      return "Pending";
    case QueueOrderSearchStatus.InProgress:
      return "In-Progress";
    case QueueOrderSearchStatus.Done:
      return "Done";
    case QueueOrderSearchStatus.Scheduled:
      return "Scheduled";
    default:
      return "Unknown";
  }
};
